import React from "react";
import { Helmet } from 'react-helmet-async';
import ContactSection from "./ContactSection";

const AboutPage = () => {

    return (
        <div className="py-20 bg-gray-900">
            <Helmet>
                <title>About Us | PeerChargeEV - India's EV Charging Network</title>
                <meta name="description" content="Learn about PeerChargeEV's mission to build a scalable, community-powered EV charging network across India." />
            </Helmet>
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-4xl font-bold text-center mb-8 text-white">About PeerChargeEV</h1>
                <p className="text-lg text-gray-400 mb-6">
                    PeerChargeEV was founded on a simple idea: to make electric vehicle ownership easier and more accessible for everyone. We believe in the power of community and technology to accelerate the transition to sustainable transportation.
                </p>
                <p className="text-lg text-gray-400 mb-6">
                    Our platform connects EV drivers with home and private charger owners, creating a peer-to-peer network that is convenient, affordable, and environmentally friendly. By allowing individuals to share their charging infrastructure, we're helping to build a more robust and resilient charging grid, one plug at a time.
                </p>
                <h2 className="text-3xl font-bold text-center my-12 text-white">Our Mission</h2>
                <p className="text-lg text-gray-400 text-center mb-12">
                    To empower EV owners and accelerate the adoption of electric vehicles by creating a global, community-driven charging network.
                </p>

                {/* Contact Section */}
                <ContactSection />
            </div>
        </div>
    );
};

export default AboutPage;